import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, ObservableInput, combineLatest, forkJoin, map, merge } from 'rxjs';
import { Product } from './../models/product.model';
import { ProductDto } from './../models/productDto.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor(private httpClient: HttpClient) { }

  getAllProducts(): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products', { headers: { 'http2': 'true' } });
  }

  getCustomProducts(data: any): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products/findAllCustomData/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
  }

  getSelectedProducts(): Observable<Product[]> {
    const host = environment.host;
    /*return this.httpClient.get<Product[]>(host + '/products?selected=true');*/
    return this.httpClient.get<Product[]>(host + '/products/getSelectedProducts/', { headers: { 'http2': 'true' } });
  }

  getAvailableProducts(): Observable<Product[]> {
    const host = environment.host;
    /*return this.httpClient.get<Product[]>(host + '/products/available=true');*/
    return this.httpClient.get<Product[]>(host + '/products/getAvailableProducts/', { headers: { 'http2': 'true' } });
  }


  searchProducts(searchKeyWords: string, data: any): Observable<any> {

    const host = environment.host;
    if (searchKeyWords) {
      /*return this.httpClient.get<Product[]>(host + '/products?name_like=' + searchKeyWords);*/
      // Sans résultat, le dashboard cherche chez les réseaux d'affiliation (ExternalSearchService)
      return this.httpClient.get<Product[]>(host + '/products/searchProducts/' + searchKeyWords + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
    } else {
      return this.httpClient.get<Product[]>(host + '/products/findAllCustomData/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
    }
  }

  searchProductsByCategory(productDto: ProductDto, data: any): Observable<Product[]> {
    const host = environment.host;
    if (productDto.category && productDto.searchKeyWords) {
      return this.httpClient.get<Product[]>(host + '/products/searchProductsByCategory/' + productDto.searchKeyWords + '/' + productDto.category + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
    } else {
      return this.categoryProductsFilter(productDto.category, data);
    }
  }

  searchProductsByAdvertiser(productDto: ProductDto, data: any): Observable<Product[]> {
    const host = environment.host;
    if (productDto.advertiser && productDto.searchKeyWords) {
      return this.httpClient.get<Product[]>(host + '/products/searchProductsByAdvertiser/' + productDto.searchKeyWords + '/' + productDto.advertiser + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
    } else {
      return this.getAdvertiserProductsFilter(productDto.advertiser, data);
    }
  }

  searchProductsByPromotionCode(searchKeyWords: string, data: any): Observable<Product[]> {
    const host = environment.host;
    if (searchKeyWords) {
      return this.httpClient.get<Product[]>(host + '/products/searchProductsByPromotionCode/' + searchKeyWords + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
    } else {
      return this.getPromotionCodeProductsFilter(data);
    }
  }

  selectProduct(product: Product): Observable<Product> {
    const host = environment.host;
    product.selected = !product.selected;
    return this.httpClient.put<Product>(host + '/products/' + product._id, product, { headers: { 'http2': 'true' } });
  }

  getProduct(_id: number): Observable<Product> {
    const host = environment.host;

    return this.httpClient.get<Product>(host + '/products/' + _id, { headers: { 'http2': 'true' } });
  }

  updateProduct(product: Product): Observable<Product> {
    const host = environment.host;
    return this.httpClient.put<Product>(host + '/products/fromFrontOffice/' + product._id, product);
  }


  categoryProductsFilter(category: string, data: any): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products/categoryProductsFilter/' + category + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
  }

  getAdvertiserProductsFilter(advertiser: string, data: any): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products/getAdvertiserProductsFilter/' + advertiser + '/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
  }



  getPromotionCodeProductsFilter(data: any): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products/getPromotionCodeProductsFilter/' + data.limit + '/' + data.skip, { headers: { 'http2': 'true' } });
  }

  // « Offres près de moi » : offres en magasin les plus proches, avec distanceKm
  getNearbyProducts(query: { lat: number; lng: number; km: number }, data: any): Observable<Product[]> {
    const host = environment.host;
    const params = { lat: query.lat, lng: query.lng, km: query.km, limit: data.limit, skip: data.skip };
    return this.httpClient.get<Product[]>(host + '/products/near', { params });
  }

  getTopVotedProducts(limit: number): Observable<Product[]> {
    const host = environment.host;
    return this.httpClient.get<Product[]>(host + '/products/getTopVotedProducts/' + limit, { headers: { 'http2': 'true' } });
  }
}
